import { Box } from "@mui/material";

export default function ErrorPage() {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100svh",
        width: "100svw",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backdropFilter: "blur(10px)",
      }}
    >
      <Box
        sx={{
          pointerEvents: "none",
          userSelect: "none",
          textAlign: "center",
          fontSize: "3em",
          color: "cornsilk",
          zIndex: 9999,
          background: "rgba(0,0,0,0.7)",
          padding: "2rem",
          border: "solid 2px #FFFFFF",
          borderRadius: "0.75rem",
          paddingLeft: "3em",
          paddingRight: "3em",
          paddingTop: "1em",
          paddingBottom: "1em",
          maxWidth: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        ERROR
      </Box>
    </Box>
  );
}
